import thunkMiddleware from 'redux-thunk';
import { compose, createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';

import promiseMiddleware from 'src/middlewares/Promise';

const middlewareVars = [promiseMiddleware, thunkMiddleware];

const middlewareFunc = composeWithDevTools(applyMiddleware(...middlewareVars));

const finalCreateStore = middlewareFunc(createStore);

// eslint-disable-next-line import/no-default-export
export default function ({ reducers, data = {} }) {
    return finalCreateStore(reducers, data);
}
